import { call, put } from "redux-saga/effects";
import axios from "../../config/AxiosConfig";
import { INTERESTED_USER_API } from "../actions/apiCollections";
import {
  interestedUsersStart,
  interestedUsersFail,
  getInterestedUsersSuccess,
} from "../actions/index";

export function* getInterestedUsersSaga(action) {
  yield put(interestedUsersStart());
  try {
    const response = yield axios.get(INTERESTED_USER_API, {
      params: {
        ...(action.search !== "" && { search: action.search }),
        limit: 10 * action.pageLimit,
      },
    });
    yield put(getInterestedUsersSuccess(response.data.data.data));
  } catch (error) {
    yield put(interestedUsersFail(error.response));
  }
}
